<template>
  <div class="simpleStorageServiceResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="bucketName"
          :placeholder="$t('RAM.common.QuerybyBucketName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:simpleStorageServiceResource:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableSimpleStorageServiceResource from "../s3/TableSimpleStorageServiceResource";
var tableSimpleStorageServiceResource = TableSimpleStorageServiceResource;
export default {
  name: "SimpleStorageServiceResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      bucketName: "",
      bucketNameSearch: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("bucketNameSearch", this.bucketName);
      tableSimpleStorageServiceResource.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.simpleStorageServiceResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/s3/SimpleStorageServiceResourceSearch.vue